<div class="full-screen justify-content-center align-items-center">
    <div class="col-10 col-offset-1 mt-6">
        <!-- Selector de "Regístrate" e "Iniciar Sesión" -->
        <div class="switch-container flex justify-content-center mb-4">
            <button class="switch-btn" [ngClass]="{'active': !isLoginMode}" (click)="setLoginMode(false)">
                Regístrate
            </button>
            <button class="switch-btn" [ngClass]="{'active': isLoginMode}" (click)="setLoginMode(true)">
                Iniciar Sesión
            </button>
        </div>
    </div>

    <div class="col-8 col-offset-2 text-center flex justify-content-center align-items-center">
        <div class="form-container text-left">
            <!-- Login Mode -->
            <ng-container *ngIf="isLoginMode; else registerMode">
                <h2 class="title">Entra a tu cuenta de Tadic List</h2>
                <p class="subtitle">Gestiona tus propiedades y búsquedas, accede a propiedades curadas para ti y
                    contacta a los dueños e interesados.</p>

                <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
                    <!-- Campo Email -->
                    <div class="form-group">
                        <input pInputText type="text" class="form-control" formControlName="username" placeholder="Email"/>
                        <div class="error-message">
                            <ul class="text-danger list-unstyled"
                                style="list-style: none; padding: 0; margin: 0; margin-top: 0"
                                *ngIf="isNotDataValid || loginForm.controls['username'].dirty">
                                <li *ngFor="let error of getValidationMessages(loginForm.controls['username'], 'Email')">
                                    <p-message severity="error" [text]="error" *ngIf="!loginForm.controls['username'].valid"></p-message>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- Campo Contraseña -->
                    <div class="form-group">
                        <input pInputText type="password" class="form-control" formControlName="password" placeholder="Contraseña"/>
                        <div class="error-message">
                            <ul class="text-danger list-unstyled"
                                style="list-style: none; padding: 0; margin: 0; margin-top: 5px"
                                *ngIf="isNotDataValid || loginForm.controls['password'].dirty">
                                <li *ngFor="let error of getValidationMessages(loginForm.controls['password'], 'Contraseña')">
                                    <p-message severity="error" [text]="error" *ngIf="!loginForm.controls['password'].valid"></p-message>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- Mensaje de error del servicio -->
                    <div class="error-message">
                        <div class="error-message">
                            <ul class="text-danger list-unstyled"
                                style="list-style: none; padding: 0; margin: 0; margin-top: 5px"
                                *ngIf="showErrorDialog">
                                <li>
                                    <p-message severity="error" [text]="dialogCode +' '+ dialogMessage" *ngIf="showErrorDialog"></p-message>
                                </li>
                            </ul>
                        </div>
                    </div>


                    <!-- Indicador de carga con spinner de pantalla completa -->
                    <div class="full-screen-spinner" *ngIf="loading">
                        <p-progressSpinner></p-progressSpinner>
                    </div>

                    <!-- Botón Iniciar sesión -->
                    <div class="form-group flex justify-content-center mb-3">
                        <button pButton type="submit" class="p-button-rounded custom-button" [disabled]="loading">
                            <span>Iniciar sesión</span>
                            <i class="pi pi-arrow-right"></i>
                        </button>
                    </div>

                    <div class="form-group flex justify-content-center mb-8">
                        <a href="#" class="link">¿Olvidaste tu contraseña?</a>
                    </div>
                </form>
            </ng-container>

            <!-- Register Mode -->
            <ng-template #registerMode>
                <h2 class="title">Crea tu cuenta</h2>
                <p class="subtitle">Accede al catálogo de propiedades curadas especialmente para ti.
                    Sube tus propiedades, contacta a los dueños y conoce más detalles
                    de las propiedades.</p>

                <form [formGroup]="registerForm" (ngSubmit)="register()">
                    <!-- Campo Email -->
                    <div class="form-group">
                        <input pInputText type="email" class="form-control" formControlName="email" placeholder="Email"/>
                        <div class="error-message">
                            <ul class="text-danger list-unstyled"
                                style="list-style: none; padding: 0; margin: 0; margin-top: 5px"
                                *ngIf="isNotDataValid || registerForm.controls['email'].dirty">
                                <li *ngFor="let error of getValidationMessages(registerForm.controls['email'], 'Email')">
                                    <p-message severity="error" [text]="error" *ngIf="!registerForm.controls['email'].valid"></p-message>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- Campo Contraseña -->
                    <div class="form-group">
                        <input pInputText type="password" class="form-control" formControlName="registerPassword" placeholder="Contraseña"/>
                        <div class="error-message">
                            <ul class="text-danger list-unstyled"
                                style="list-style: none; padding: 0; margin: 0; margin-top: 5px"
                                *ngIf="isNotDataValid || registerForm.controls['registerPassword'].dirty">
                                <li *ngFor="let error of getValidationMessages(registerForm.controls['registerPassword'], 'Contraseña')">
                                    <p-message severity="error" [text]="error" *ngIf="!registerForm.controls['registerPassword'].valid"></p-message>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- Checkbox Newsletter -->
                    <div class="form-group flex align-items-start mb-3">
                        <p-checkbox [binary]="true" name="newsletter" formControlName="newsletter"></p-checkbox>
                        <label class="checkbox-label">Quiero suscribirme al newsletter de Tadic List para recibir
                            información sobre nuevas propiedades, eventos exclusivos y mucho más.
                            <a href="#">Descubre más</a></label>
                    </div>

                    <!-- Checkbox Términos y Condiciones -->
                    <div class="form-group flex align-items-start mb-3">
                        <p-checkbox [binary]="true" name="termsAccepted" formControlName="termsAccepted"></p-checkbox>
                        <label class="checkbox-label">He leído y acepto la <a href="#">Política de Privacidad</a> y los <a href="#">Términos & Condiciones</a>.</label>
                        <div *ngIf="registerForm.get('termsAccepted')?.touched && registerForm.get('termsAccepted')?.errors?.['requiredTrue']" class="error-message">
                            Debes aceptar los términos y condiciones.
                        </div>
                    </div>

                    <!-- Mensaje de error del servicio -->
                    <div class="error-message">
                        <div class="error-message">
                            <ul class="text-danger list-unstyled"
                                style="list-style: none; padding: 0; margin: 0; margin-top: 5px"
                                *ngIf="showErrorDialog">
                                <li>
                                    <p-message severity="error" [text]="dialogCode +' '+ dialogMessage" *ngIf="showErrorDialog"></p-message>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- Botón Crear Cuenta -->
                    <div class="form-group flex justify-content-center">
                        <button pButton type="submit" class="p-button-rounded custom-button" [disabled]="loading || registerForm.invalid">
                            <span>Crear cuenta</span>
                            <i class="pi pi-arrow-right ml-2"></i>
                        </button>
                    </div>

                    <!-- Indicador de carga con spinner de pantalla completa -->
                    <div class="full-screen-spinner" *ngIf="loading">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                </form>
            </ng-template>
        </div>
    </div>
</div>
